import { render, staticRenderFns } from "./RiskSurveySurroundings.vue?vue&type=template&id=b1505712&"
import script from "./RiskSurveySurroundings.vue?vue&type=script&lang=js&"
export * from "./RiskSurveySurroundings.vue?vue&type=script&lang=js&"
import style0 from "./RiskSurveySurroundings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports